// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks

// types

const ItmTag = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'itm';
    const isExistScript = document.getElementById(scriptId);
    if (!!isExistScript) isExistScript.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.text = `
      (function(w,d,s){
        var f=d.getElementsByTagName(s)[0],j=d.createElement(s);
        j.async=true;j.src='https://dmp.im-apps.net/js/1025219/0001/itm.js';
        f.parentNode.insertBefore(j, f);
      })(window,document,'script');
      `;
    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return <></>;
};

export default ItmTag;
